import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, TextArea } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section2({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-42">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-43">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-44">
          <span className="text-dorado mr-2" data-id="element-45">Sección 02 ·</span>
          Tu Objetivo
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-46">
          Define con claridad qué buscas lograr en estos 90 días.
        </p>
      </div>

      <FormField label="¿Cuál es tu objetivo principal en este momento?" name="objetivo" error={errors.objetivo} required description="Sé lo más específico posible (ej. perder peso, ganar energía, mejorar digestión, sanar relación con la comida)." data-id="element-47">
        <TextArea id="objetivo" value={data.objetivo} onChange={e => onChange('objetivo', e.target.value)} error={!!errors.objetivo} placeholder="Escribe tu objetivo principal aquí..." data-id="element-48" />
      </FormField>

      <FormField label="¿Por qué es importante para ti lograr esto AHORA?" name="importancia" error={errors.importancia} required data-id="element-49">
        <TextArea id="importancia" value={data.importancia} onChange={e => onChange('importancia', e.target.value)} error={!!errors.importancia} placeholder="¿Qué te motiva a empezar hoy?" data-id="element-50" />
      </FormField>

      <FormField label="¿Cómo te sentirías y cómo cambiaría tu vida al lograrlo?" name="sentimiento" error={errors.sentimiento} required data-id="element-51">
        <TextArea id="sentimiento" value={data.sentimiento} onChange={e => onChange('sentimiento', e.target.value)} error={!!errors.sentimiento} placeholder="Visualiza tu éxito..." data-id="element-52" />
      </FormField>
    </div>;
}